import { IS_BP_MANAGER } from "@/consts";
import { ref } from "vue";

type MatomoStatus = "none" | "cancelled" | "ready";

const status = ref<MatomoStatus>("none");

export const init = (): void => {
  if (window.location.host.includes("localhost")) return;
  if (status.value !== "none") {
    return;
  }

  if (IS_BP_MANAGER) {
    status.value = "cancelled";
    return;
  }

  const _paq = (window._paq = window._paq || []);
  (function () {
    const u = "//aws.proreact.dk/tracking/";
    _paq.push(["setTrackerUrl", u + "matomo.php"]);
    _paq.push(["setSiteId", "13"]);

    const d = document;
    const g = d.createElement("script");
    const s = d.getElementsByTagName("script")[0];

    g.type = "text/javascript";
    g.async = true;
    g.defer = true;
    g.src = u + "matomo.js";

    if (s && s.parentNode) {
      s.parentNode.insertBefore(g, s);
    }
  })();

  status.value = "ready";
};

export function useMatomo() {
  init();
  const _paq = (window._paq = window._paq || []);

  const trackEvent = (
    action: string,
    category: string = "uncategorized",
    extraInfo?: string,
  ) => {
    if (status.value !== "ready") {
      return;
    }

    _paq.push(["trackEvent", `${category}`, `${action}`, `${extraInfo}`]);
  };

  const trackPageView = () => {
    if (status.value !== "ready") {
      return;
    }
    _paq.push(["setCustomUrl", window.location.href]);
    _paq.push(["trackPageView"]);
  };

  return {
    trackEvent,
    trackPageView,
  };
}
